import api from './api';

/**
 * Generate and download a project PDF report.
 *
 * @param {Object} options
 * @param {number|string} options.projectId
 * @param {'project'|'sprint'|'date_range'} options.scope
 * @param {number|null} [options.sprintId]
 * @param {string|null} [options.startDateIso] - ISO timestamp string
 * @param {string|null} [options.endDateIso] - ISO timestamp string
 * @param {function(boolean):void} [options.setLoading] - optional setter for local loading state
 */
export async function generateAndDownloadReport({
  projectId,
  scope,
  sprintId = null,
  startDateIso = null,
  endDateIso = null,
  setLoading,
}) {
  if (setLoading) setLoading(true);

  try {
    const payload = {
      scope,
      sprint_id: sprintId,
      start_date: startDateIso,
      end_date: endDateIso,
    };

    const response = await api.post(
      `/projects/${projectId}/report`,
      payload,
      { responseType: 'blob' }
    );

    const disposition = response.headers['content-disposition'] || '';
    let filename = 'project-report.pdf';
    const match = disposition.match(/filename="(.+?)"/);
    if (match && match[1]) {
      filename = match[1];
    }

    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } finally {
    if (setLoading) setLoading(false);
  }
}

